import { IPromise, IScope } from "angular";
import { AccountService } from "../../accounts/accountsService";
import { EnvironmentService, isLocalhost } from "@gtmhub/env";
import { IStateInit } from "@gtmhub/core/routing";
import { storage } from "@gtmhub/core/storage";
import { copyToClipboard } from "@gtmhub/shared/dom";

export interface IJiraScope extends IScope {
  accountId: string;
  token: string;
  dataCenter: string;
  webhookUrl: string;
  copy(string: string): void;
}

export class JiraCtrl implements IStateInit {
  public static $inject = ["$scope", "AccountService", "EnvironmentService"];

  constructor(private $scope: IJiraScope, private accountService: AccountService, private env: EnvironmentService) {
    this.$scope.copy = this.copy;
    this.$scope.accountId = storage.get("accountId");
  }

  public stateInit(): IPromise<unknown> {
    return this.getToken();
  }

  private generateWebHook = () => {
    const backend = this.env.getApiEndpoint();

    if (isLocalhost(backend)) {
      this.$scope.dataCenter = "local";
    } else if (backend.split("staging.gtmhub").length > 1) {
      this.$scope.dataCenter = "staging";
    } else {
      this.$scope.dataCenter = this.env.getDC();
    }

    return (
      this.env.getApiEndpoint().split("api/v1/")[0] +
      "jira/issues-changelog?account=" +
      this.$scope.accountId +
      "&token=" +
      this.$scope.token +
      "&dc=" +
      this.$scope.dataCenter
    );
  };

  private copy = (text: string) => {
    copyToClipboard(text);
  };

  private getToken = (): IPromise<unknown> => {
    return this.accountService.getGeneratedBasicToken().then((result) => {
      result = result.replace(/"/g, "");
      if (result !== "") {
        this.$scope.token = result;
        this.$scope.webhookUrl = this.generateWebHook();
      } else {
        this.generateToken();
      }
    });
  };

  private generateToken = () => {
    this.accountService.generateBasicToken().then((result) => {
      this.$scope.token = result.replace(/"/g, "");
      this.$scope.webhookUrl = this.generateWebHook();
    });
  };
}
